// Meter: a labelled amount of a whole (12 of 20 runners busy) as words and a bar; the bar turns
// warning at `warnAt` (a value, default 80% of max) so a nearly-full meter reads at a glance.
import { cn } from './cn';

export function Meter({
  label,
  value,
  max,
  warnAt = max * 0.8,
  valueText,
  className,
}: {
  label: string;
  value: number;
  max: number;
  warnAt?: number;
  valueText?: string;
  className?: string;
}) {
  const pct = max > 0 ? Math.max(0, Math.min(100, (value / max) * 100)) : 0;
  const warn = value >= warnAt;
  const text = valueText ?? `${value} of ${max}`;
  return (
    <div className={cn('grid min-w-0 gap-1', className)}>
      <div className="flex items-baseline justify-between gap-2 text-[12px]">
        <span className="text-ink-muted">{label}</span>
        <span className={cn('font-mono text-[11.5px] font-semibold', warn ? 'text-warning-ink' : 'text-ink-display')}>{text}</span>
      </div>
      <div
        role="meter"
        aria-label={label}
        aria-valuemin={0}
        aria-valuemax={max}
        aria-valuenow={value}
        aria-valuetext={text}
        className="h-1.5 w-full overflow-hidden rounded-full border border-hairline bg-surface"
      >
        <div className={cn('h-full rounded-full', warn ? 'bg-warning' : 'bg-accent')} style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}
